<mat-button-toggle-group multiple>
  <mat-button-toggle
    (click)="toggleShowRoute()"
    [checked]="showRoute$ | async"
    matTooltip="Toggle Route"
  >
    <mat-icon class="material-symbols-outlined"> near_me </mat-icon>
  </mat-button-toggle>
  <mat-button-toggle
    [checked]="useOrthographicCamera$ | async"
    [matTooltip]="toggleOrthographicCameraTooltip"
    (click)="toggleOrthographicCamera()"
  >
    <fa-icon [fixedWidth]="true" [icon]="faPlane"></fa-icon
  ></mat-button-toggle>
  <mat-button-toggle
    matTooltip="Toggle Ground"
    (click)="toggleHideGround()"
    [checked]="hideGround$ | async"
  >
    <fa-icon [fixedWidth]="true" [icon]="faMinusSquare"></fa-icon>
  </mat-button-toggle>
  <mat-button-toggle
    class="without-checked-state"
    (click)="resetCamera({ source: 'button' })"
    [matTooltip]="resetCameraTooltip"
  >
    <mat-icon class="material-symbols-outlined"
      >center_focus_weak</mat-icon
    ></mat-button-toggle
  >
</mat-button-toggle-group>
